import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportFilter } from '@reporting/interfaces/report-filter.interface';
import { NotifyService } from '@app/services';
import { Report } from '@reporting/services/queries/report';
import { DeprecatedConfirmationDialogComponent } from '@app/components';
import { CustomReportingService } from '@app/modules/reporting/services/custom-reporting.service';
import { CustomReportQuery } from '@app/models/reporting/custom-report-query.model';

@Component({
    templateUrl: './custom-report-data.view.html',
    styleUrls: ['./custom-report-data.style.scss'],
})
export class CustomReportDataView implements OnInit {
    @ViewChild('confirmDeleteCustomReportDialog', { static: true })
    confirmDeleteCustomReportDialog: DeprecatedConfirmationDialogComponent;

    customReportQuery: CustomReportQuery = new CustomReportQuery();

    isLoading = false;
    report: Report;
    filters: ReportFilter[];
    id: number;
    reportTitle: string;

    constructor(
        public route: ActivatedRoute,
        protected notify: NotifyService,
        private customReportingService: CustomReportingService,
        private router: Router
    ) {
        this.report = this.route.snapshot.data.report;
        this.id = this.route.snapshot.params.id;
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.getCustomReportQuery().then((customReportQuery: CustomReportQuery) => {
            this.customReportQuery = customReportQuery;
            this.reportTitle = this.customReportQuery.name;
            this.isLoading = false;
        });
    }

    onFilter(filters: ReportFilter[]): void {
        this.isLoading = true;
        this.filters = filters;
        this.report
            .filters(this.filters)
            .get()
            .then((report: Report) => {
                this.report = report;
                this.isLoading = false;
            });
    }

    onExport(contentType: string): void {
        this.report.export(contentType).catch(() => {
            this.notify.error('Error exporting report');
        });
    }

    onEdit(): void {
        this.router.navigate(['/reporting', 'custom-reports', String(this.customReportQuery.id)]);
    }

    onDelete(): void {
        this.setCustomReportDeleteDialogHeader();

        this.confirmDeleteCustomReportDialog.show().then((confirm) => {
            if (!confirm) {
                return;
            }

            this.isLoading = true;
            this.customReportingService.deleteCustomReport(this.customReportQuery).then(() => {
                this.router.navigate(['/reporting', 'custom-reports']);
                this.isLoading = false;
            });
        });
    }

    private setCustomReportDeleteDialogHeader(): void {
        this.confirmDeleteCustomReportDialog.header = `Delete ${this.customReportQuery.name}?`;
    }

    private async getCustomReportQuery(): Promise<CustomReportQuery> {
        return CustomReportQuery.with(['filters']).param('custom_report_type', 'employee').find(this.id);
    }
}
